import React, { useEffect, useState } from 'react';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../components/Component';
import { Badge, Button } from 'reactstrap';
import * as app_consts from "../../../utils/app_consts";
import AuthTenantPageError from '../../error/AuthTenantPageError';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { RETRIEVE_TENANT_STOCK_TAKE_LIST_API } from '../../../api/api_data';
import { fail_retrieve_tenant_stock_take_list, loading_retrieve_tenant_stock_take_list, reset_retrieve_tenant_stock_take_list, success_retrieve_tenant_stock_take_list } from '../../../reducers/auth_tenant/retrieve_tenant_stock_take_list_Slice';
import { RETRIEVE_TENANT_STOCK_TAKE_LIST_ERROR_MSG, RETRIEVE_TENANT_STOCK_TAKE_LIST_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { addThreeDots, formatToSentenceCase, messageToast } from '../../../utils/Utils';
import { Link } from 'react-router-dom';
import AddStockTakeModal from '../../../components/modal/AddStockTakeModal';
import moment from 'moment';

const StockTakeManagement = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const [sm, updateSm] = useState(false);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [add_stock_take_modal, setStockTakeModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);

  useEffect(() => {
    retrieve_stock_take_list();
  }, []);

  // Retrieve Stock Take list
  const retrieve_stock_take_list = () => {
    setError("");
    setLoading(true);
    // Disptach
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_stock_take_list, success_retrieve_tenant_stock_take_list, fail_retrieve_tenant_stock_take_list, RETRIEVE_TENANT_STOCK_TAKE_LIST_ERROR_MSG, RETRIEVE_TENANT_STOCK_TAKE_LIST_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_STOCK_TAKE_LIST_API}`));
  };

  // Listener
  const retrieve_tenant_stock_take_list_listener = useSelector((state) => state.retrieve_tenant_stock_take_list.retrieve_tenant_stock_take_list);

  useEffect(() => {
    if (retrieve_tenant_stock_take_list_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_stock_take_list_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_stock_take_list_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_stock_take_list_listener.message);
          messageToast(retrieve_tenant_stock_take_list_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_stock_take_list_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_stock_take_list_listener.data);
          setCurrentPageData(retrieve_tenant_stock_take_list_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_stock_take_list());
      }
    }
  }, [retrieve_tenant_stock_take_list_listener]);

  const successAddStockTakeModal = () => {
    retrieve_stock_take_list();
    setStockTakeModal(!add_stock_take_modal);
  };

  const closeAddStockTakeModal = () => {
    setStockTakeModal(!add_stock_take_modal);
  };
  // UseEffect for Search 
  useEffect(() => {
    filtered_stock_takes(searchTerm);
  }, [searchTerm]);

  const filtered_stock_takes = (searchItem) => {
    let displayedStockTake;

    displayedStockTake = page_data?.filter((item) => {
      const combinedParams = [
        item?.warehouse?.name, ,
        item?.name,
        item?.employee?.user?.first_name ? `${item?.employee?.user?.first_name} ${item?.employee?.user?.last_name}` : "--",
        item?.stock_balance_start_date ? moment(item?.stock_balance_start_date).format("YYYY-MM-DD HH:mm:ss") : "--",
        item?.stock_balance_end_date ? moment(item?.stock_balance_end_date).format("YYYY-MM-DD HH:mm:ss") : "--",
        item?.employee?.user?.first_name ? `${item?.employee?.user?.first_name} ${item?.employee?.user?.last_name}` : "--",
        item.status?.replace(/_/g, ' ').toUpperCase(),
      ]
        .join(" ")
        .toLowerCase();

      return combinedParams.includes(searchItem.toLowerCase());
    }).slice(startIndex, endIndex);

    setCurrentPageData(displayedStockTake);
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate the start and end index for the current page
  const startIndex = (currentPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Stock Take` : " Stock Take"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page> Stock Take</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && ` Stock Take ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_stock_take_list();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            {
              !(loading || error) && (
                <>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#more"
                        className="btn btn-icon btn-trigger toggle-expand me-n1"
                        onClick={(ev) => {
                          ev.preventDefault();
                          updateSm(!sm);
                        }}
                      >
                        <Icon name="more-v"></Icon>
                      </a>
                      <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                        <ul className="nk-block-tools g-3">
                          <li>
                            <div className="form-control-wrap">
                              <div className="form-icon form-icon-right">
                                <Icon name="search"></Icon>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                id="default-04"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                placeholder="Search for Stock Takes"
                              />
                            </div>
                          </li>
                          {
                            (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.ADD_STOCK_TAKE)) && (
                              <>
                                <li className="nk-block-tools-opt">
                                  <Button
                                    className="toggle btn-icon d-md-none"
                                    color="primary"
                                    onClick={() => {
                                      setStockTakeModal(!add_stock_take_modal);
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                  </Button>
                                  <Button
                                    className="toggle d-none d-md-inline-flex"
                                    color="primary"
                                    onClick={() => {
                                      setStockTakeModal(!add_stock_take_modal);
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                    <span>Add Stock Take</span>
                                  </Button>
                                </li>
                              </>
                            )
                          }
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </>
              )
            }
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Stock Take List..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && page_data?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">Reference No</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Warehouse</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Balance Start Date</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Balance End Date</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Created On</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Done By</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Status</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link to={`/${tenant_info.url_prefix}/stock_take/${item?.reference_number}`}>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {item?.reference_number || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                            <span>{item?.name || "--"}</span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span> {item.warehouse?.name ? addThreeDots(item?.warehouse?.name, 30) : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.stock_balance_start_date ? moment(item?.stock_balance_start_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.stock_balance_end_date ? moment(item?.stock_balance_end_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-date">{item?.employee?.user?.first_name ? `${item?.employee?.user?.first_name} ${item?.employee?.user?.last_name}` : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            item?.status === app_consts.COMPLETED_LOWER
                                              ? "success"
                                              : "warning"
                                          }
                                          className="badge-dot"
                                        >
                                          {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                                        </Badge>
                                      </span>
                                    </DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                      <Link to={`/${tenant_info.url_prefix}/stock_take/${item?.reference_number}`}>
                                        <div className="tb-odr-btns d-none d-sm-inline">
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </div>
                                        <Button className="btn-pd-auto d-sm-none">
                                          <Icon name="chevron-right"></Icon>
                                        </Button>
                                      </Link>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : null}
                            </div>
                            {currentItems?.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </Block>

                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Stock Take Data Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
      <AddStockTakeModal isOpen={add_stock_take_modal} successFunction={successAddStockTakeModal} closeModal={closeAddStockTakeModal} tenant_info={tenant_info} user_info={user_info} />
    </>
  );
};

export default StockTakeManagement;